<template>
  <transition
    name="popup-top"
    mode="in-out"
  >
    <div
      v-if="!toggled"
      class="fixed top-0 left-0 z-40 hidden w-full h-20 px-5 text-white bg-danger-500 lg:block"
    >
      <button
        class="absolute top-0 right-0 m-6 text-2xl transition duration-200 opacity-60 hover:opacity-100"
        @click="close"
      >
        <i class="fal fa-times" />
      </button>
      <div class="flex justify-center h-full">
        <div class="flex items-center mx-auto space-x-5 lg:max-w-5xl">
          <p class="text-xl font-light opacity-80">
            {{ popupData.message }}
          </p>
          <div
            v-if="popupData.action.enable"
            class="flex-shrink-0"
          >
            <a
              :href="popupData.action.link"
              class="btn btn-default"
            >
              {{ popupData.action.label }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      popupData: window.popupTop,
      toggled: true,
    };
  },
  mounted() {
    if (this.$cookies.get("popup-top-id")) {
      this.checkLastModified();
    }

    this.$cookies.set("popup-top-id", this.popupData.id);
    this.init();
  },
  methods: {
    init() {
      if (!this.popupData.enable) {
        this.$cookies.remove("popup-top-toggled");
      } else {
        this.showPopup();
      }
    },
    checkLastModified() {
      if (this.$cookies.get("popup-top-id") !== this.popupData.id) {
        this.$cookies.remove("popup-top-toggled");
      }
    },
    close() {
      this.toggled = true;
      this.$cookies.set("popup-top-toggled", true);
      this.hide();
    },
    hide() {
      this.toggled = true;
      document.querySelector(".js-navigation").classList.remove("mt-nav");
      document.querySelector("body").classList.remove("lg:pt-48");
      document.querySelector("body").classList.add("lg:pt-28");
    },
    showPopup() {
      if (this.$cookies.get("popup-top-toggled")) {
        this.toggled = true;
      } else {
        this.toggled = false;
        document.querySelector(".js-navigation").classList.add("mt-nav");
        document.querySelector("body").classList.add("lg:pt-48");
        document.querySelector("body").classList.remove("lg:pt-28");
      }
    },
  },
};
</script>

<style>
.popup-top-enter-active,
.popup-top-leave-active {
  @apply transform transition-all duration-500;
}

.popup-top-leave-to {
  @apply opacity-0 -translate-y-full;
}
</style>
